export default "__VITE_ASSET__Cjo9yiou__"